module.exports = __webpack_public_path__ + "img/open.08348ed7.png";